<fa-icon (click)="close()" [icon]="faTimes" class="close-page"></fa-icon>